import App from './App';
import 'antd/dist/reset.css';
import '../src/styles/style.css';

const Wrap = () => (
  <App />
);

export default Wrap;
